import { BusConnectionProvider } from 'apprise-frontend-events/context'
import React from "react"
import { EventInitialiser } from "./initialiser"

export type EventsProps = React.PropsWithChildren<Partial<{

    debug: boolean

}>>


export const Events = (props: EventsProps) => {

    const { children } = props

    return <BusConnectionProvider>
        <EventInitialiser {...props} >
                {children}
        </EventInitialiser>
    </BusConnectionProvider>


}






